function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5 8.5L12.5 10.5L10.5 12.5",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 8.5L3.5 10.5L5.5 12.5",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 8.5L7 12.5",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.333 2.5H1.66634C0.929961 2.5 0.333008 3.09695 0.333008 3.83333V13.1667C0.333008 13.903 0.929961 14.5 1.66634 14.5H14.333C15.0694 14.5 15.6663 13.903 15.6663 13.1667V3.83333C15.6663 3.09695 15.0694 2.5 14.333 2.5Z",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.333008 5.83203H15.6663",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.66667 4C2.69963 4 2.73185 4.00977 2.75926 4.02809C2.78667 4.0464 2.80803 4.07243 2.82065 4.10289C2.83326 4.13334 2.83656 4.16685 2.83013 4.19918C2.8237 4.23151 2.80783 4.26121 2.78452 4.28452C2.76121 4.30783 2.73151 4.3237 2.69918 4.33013C2.66685 4.33656 2.63334 4.33326 2.60289 4.32065C2.57243 4.30803 2.5464 4.28667 2.52809 4.25926C2.50977 4.23185 2.5 4.19963 2.5 4.16667C2.5 4.12246 2.51756 4.08007 2.54882 4.04882C2.58007 4.01756 2.62246 4 2.66667 4",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.66667 4C4.69963 4 4.73185 4.00977 4.75926 4.02809C4.78667 4.0464 4.80803 4.07243 4.82065 4.10289C4.83326 4.13334 4.83656 4.16685 4.83013 4.19918C4.8237 4.23151 4.80783 4.26121 4.78452 4.28452C4.76121 4.30783 4.73151 4.3237 4.69918 4.33013C4.66685 4.33656 4.63334 4.33326 4.60289 4.32065C4.57243 4.30803 4.5464 4.28667 4.52809 4.25926C4.50977 4.23185 4.5 4.19963 4.5 4.16667C4.5 4.12246 4.51756 4.08007 4.54882 4.04882C4.58007 4.01756 4.62246 4 4.66667 4Z",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.66667 4C6.69963 4 6.73185 4.00977 6.75926 4.02809C6.78667 4.0464 6.80803 4.07243 6.82065 4.10289C6.83326 4.13334 6.83656 4.16685 6.83013 4.19918C6.8237 4.23151 6.80783 4.26121 6.78452 4.28452C6.76121 4.30783 6.73151 4.3237 6.69918 4.33013C6.66685 4.33656 6.63334 4.33326 6.60289 4.32065C6.57243 4.30803 6.5464 4.28667 6.52809 4.25926C6.50977 4.23185 6.5 4.19963 6.5 4.16667C6.5 4.12246 6.51756 4.08007 6.54882 4.04882C6.58007 4.01756 6.62246 4 6.66667 4Z",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0 0.5)"
})));

var SvgCode = function SvgCode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/code.fc565954.svg";
export { ForwardRef as ReactComponent };